import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { categories } from '../../data/carData';
import OpelCorsa from "../../assets/images/opelcorsa.jpg";
import Peugeot208 from "../../assets/images/p-208.jpg";
import Crossland from "../../assets/images/opel-crossland.webp";
import MiniCooper from "../../assets/images/MINI-COOPER-Cabrio-Auto-1.png.webp";
import Wrangler from "../../assets/images/JEEP-WRANGLER-Auto-1.png";
import WranglerSahara from "../../assets/images/JEEP-WRANGLER-1.png.webp";
import Berlingo from "../../assets/images/CITROEN-BERLINGO-Auto.png.webp";
import ATV450 from "../../assets/images/5_14f72470629695dca3487f902b2c012f.png.webp";
import Buggy800 from "../../assets/images/CF-MOTO-BUGGY-800cc-1.png.webp";
import Fiat500 from "../../assets/images/FIAT-500-Auto-Cabrio-1.png.webp";
import bike from "../../assets/images/125bike.png";

const categoryImages = {
  'Economy': OpelCorsa,
  'Electric': Peugeot208,
  'Standard': Crossland,
  'Cabrio': Fiat500,
  'Jeep Wrangler': WranglerSahara,
  'Jeep-SUV-Family': Wrangler,
  'Mini Vans': Berlingo,
  'ATV-Quads': ATV450,
  'Special': MiniCooper,
  'Motorbikes': bike,
};

const orderedCategories = [
  'Economy',
  'Electric',
  'Standard',
  'ATV-Quads',
  'Cabrio',
  'Jeep Wrangler',
  'Jeep-SUV-Family',
  'Mini Vans',
  'Motorbikes',
  'Special'
];

const CategorySelector = ({ selectedCategory, onCategoryChange }) => {
  const [showAll, setShowAll] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const visibleCategories = showAll ? orderedCategories : orderedCategories.slice(0, 3);

  const handleShowAll = () => {
    setIsAnimating(true);
    setShowAll(!showAll);
  };

  return (
    <div className="mb-8 Aleo">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {visibleCategories.map((category, index) => (
          <button
            key={category}
            className={`flex items-center p-4 rounded-lg border transition-all duration-300 ease-in-out transform hover:scale-102
              animate-fade-in-down ${isAnimating ? 'animate-slide-in' : ''}
              ${selectedCategory.includes(category) ? 'border-red-500 border-b-4' : 'border-gray-200 hover:border-red-300'}
            `}
            style={{
              animationDelay: `${index * 100}ms`
            }}
            onClick={() => {
              if (selectedCategory.includes(category)) {
                onCategoryChange(selectedCategory.filter(cat => cat !== category));
              } else {
                onCategoryChange([...selectedCategory, category]);
              }
            }}
          >
            <img
              src={categoryImages[category]}
              alt={category}
              className="w-20 h-12 object-contain"
            />
            <span className="ml-nt-medium">{category}</span>
          </button>
        ))}
      </div>
      
      {orderedCategories.length > 3 && (
        <button
          onClick={handleShowAll}
          className="flex items-center justify-center w-full py-2 text-red-600 hover:text-red-700 transition-colors duration-300 group"
        >
          <span className="mr-2 group-hover:scale-105 transition-transform duration-300">
            {showAll ? 'Show Less' : 'Show More'}
          </span>
          <div className="transform transition-transform duration-300 group-hover:scale-110">
            {showAll ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        </button>
      )}

      <style jsx>{`
        @keyframes fade-in-down {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-down {
          animation: fade-in-down 0.5s ease-out forwards;
        }

        .animate-slide-in {
          animation: slide-in 0.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CategorySelector;